<template>
  <div class="v-header clearfix">
    <div class="logo left">
      <i class="iconfont icon-a-logo1" v-show="isShowIcon"></i>
      <img :src="imgUrl" v-show="isShowImg" style="position:relative;top:15px;"/>
    </div>
    <div class="v-navigation left">
      <ul class="clearfix">
        <li class="left" v-for="(item, index) in navigation" :key="index" :class="{ active: navActive == item.name }">
          <a v-if="item.title !== '交易动态'" :href="item.href" @click="navigationClick(item)" target="_blank">
            <i class="iconfont" :class="item.icon"></i>
            {{ item.title }}
          </a>
          <a v-else :href="item.href" target="_blank">
            <i class="iconfont" :class="item.icon"></i>
            {{ item.title }}
          </a>
        </li>
      </ul>
    </div>

    <div class="right v-login">
      <div v-if="noLogin" @click="loginHandle" class="login-button">
        <span>登录</span>
      </div>
<!--      <el-dropdown v-if="!noLogin" trigger="click" @command="handleCommand">-->
<!--        <span class="el-dropdown-link"> <i class="icon-iconfontgerenzhongxin iconfont"></i>系统管理员<i class="el-icon-arrow-down el-icon&#45;&#45;right"></i> </span>-->
<!--        <el-dropdown-menu slot="dropdown">-->
<!--          <el-dropdown-item command="personalCenter"> <i class="iconfont icon-iconfontgerenzhongxin"></i>个人中心 </el-dropdown-item>-->
<!--          <el-dropdown-item> <i class="iconfont icon-tuichu"></i>退出登录 </el-dropdown-item>-->
<!--        </el-dropdown-menu>-->
<!--      </el-dropdown>-->
    </div>
     <div class="right maintenance ">
                <span class="icon">
                    <i class="iconfont icon-phone"></i>
                </span>
                <span class="phone">咨询电话:</span>
                <span class="phone">0731-23220268</span>
      </div>
  </div>
</template>
<script>
import { mapResourceApi } from '@/api/mapResourceApi'
import { xzqUtils } from '@/views/class/mapmanager'
import ll from '@/assets/images/logo01.png'
import cz from '@/assets/images/logo5.png'
export default {
  name: 'vHeader',
  data() {
    return {
      loginShow: false,
      navigation: [
        {
          title: '云上看地',
          icon: 'icon-yunshangkandi',
          name: 'index'
        },
        {
          title: '政策法规',
          icon: 'icon-zhengcefagui',
          name: 'policiesRegulations'
        },
        /*  {
          title: '咨询服务',
          icon: 'icon-zixunfuwu',
          name: 'consultingServices'
        }, */
        {
          title: '交易动态',
          icon: 'icon-jiaoyidongtai',
          href: 'http://www.zzzyjy.cn/019/019001/019001001/moreinfo2.html'
        }
      ],
      noLogin: true, // 是否已登录
      isShowIcon: true,
      isShowImg: false,
      imgUrl: ''
    }
  },
  computed: {
    navActive: {
      get() {
        return this.$store.state.activeIndex
      }
    }
  },
  created() {
    for (let i = 0; i < city.length; i++) {
      if (city[i].check === true) {
        const cityName = city[i].cityname
        if (cityName === '株洲市') {
          this.isShowImg = false
          this.isShowIcon = true
        } else {
          this.isShowImg = true
          this.isShowIcon = false
          if (city[i].cityname === '郴州市') {
            this.imgUrl = cz
          } else if (city[i].cityname === '醴陵市') {
            this.imgUrl = ll
          }
        }
        this.initXzqUtils(city[i].cityname)
      }
    }
  },
  methods: {
    initXzqUtils(cityname) {
      const param = {}
      param.cantoncity = cityname
      mapResourceApi.selectByCityName(param).then(res => {
        if (res.code === '200') {
          if (res.data.length > 0) {
            xzqUtils.datas = res.data
            const txzqNameArray = []
            const txzqEidtArray = []
            const txzqArray = [{
              label: '全部',
              value: '0'
            }]
            for (let i = 0; i < res.data.length; i++) {
              const datas = []
              datas.label = res.data[i].cantonname
              datas.value = res.data[i].cantoncode
              txzqNameArray.push(res.data[i].cantonname)
              txzqEidtArray.push(datas)
              txzqArray.push(datas)
            }
            xzqUtils.xzqNameArray = txzqNameArray
            xzqUtils.xzqEidtArray = txzqEidtArray
            xzqUtils.xzqArray = txzqArray
          }
        }
      })
    },
    navigationClick(item) {
      this.$store.commit('set_active_index', item.name)
      this.$router.push({
        name: item.name,
        query: {}
      })
    },
    loginHandle() {
      const localhostPaht = location.origin
      const index = localhostPaht + '/login'
      window.open(index)
      /* this.$router.push({
        name: 'login',
        query: {}
      }) */
    }
    // handleCommand(command) {
    //   if (command === 'personalCenter') {
    //     this.$router.push({ path: '/personalCenter' })
    //   } else {
    //     this.$router.push({ path: '/' })
    //   }
    // }
  }
}
</script>
<style lang='scss' scoped>
.v-header {
  height: 100%;
  background: #0F2142;
  padding-left: 20px;
  line-height: 60px;
  .logo{
    height: 100%;
    i.iconfont{
      color: #fff;
      font-size: 30px;
    }
  }
  .maintenance{
      width: 300px;
      height: 28px;
             /*    background: #2b3950; */
      line-height: 52px;
      padding: 5px 10px 12px 23px;
      .icon{
          width: 24px;
          height: 24px;
          background: rgba(255,255,255,0.10);
          border-radius: 50%;
          text-align: center;
          line-height: 24px;
          display: inline-block;
          vertical-align: middle;
          margin-right: 5px;
          i.iconfont{
              font-size: 12px;
          }
      }
      .phone{
          line-height: 24px;
          vertical-align: middle;
          font-size: 16px;
        /*   font-weight: bold; */
          color: #cccccc;
      }
      .people{
          vertical-align: middle;
          font-size: 14px;
          font-weight: normal;
          color: #cccccc;
          margin-right: 10px;
      }
  }
  .v-navigation {
    font-size: 18px;
    margin-left: 115px;
    li {
      cursor: pointer;
      height: 60px;
      line-height: 60px;
      width: 132px;
      text-align: center;
      color: #c4c8d0;
      border-bottom: 2px solid transparent;
      a{
        display: block;
        color: #c4c8d0;
        &:hover{
          color: #fff;
        }
      }
      &.active {
        background: #182f5a;
        border-bottom: 2px solid #fff;
        color: #fff;
      }
      &:hover {
        background: #182f5a;
        color: #fff;
      }
      .iconfont{
        font-size: 18px;
      }
    }
  }
  .v-login{
    .login-button{
      width: 96px;
      height: 60px;
      background: rgba(255,255,255,0.2);
      font-size: 16px;
      text-align: center;
      color: #ffffff;
      cursor: pointer;
    }
    .el-dropdown {
      font-size: 14px;
      line-height: 60px !important;
      .el-dropdown-link {
        cursor: pointer;
      }
    }
  }
}

/*.v-navigation li {*/
/*  padding: 0px 10px;*/
/*  cursor: pointer;*/
/*  height: 50px;*/
/*  line-height: 44px;*/
/*}*/
/*.v-navigation li.active {*/
/*  border-bottom: 3px solid #ffffff;*/
/*  background: #378ae6;*/
/*}*/
/*.v-navigation li:hover {*/
/*  background: #378ae6;*/
/*}*/
</style>
